export const CHAIN_SETTINGS = {
  // BSC - Currently enabled (primary focus)
  BSC: {
    enabled: true,
    mainnet: { id: 56, priority: 1 },
    testnet: { id: 97, priority: 2 },
    defaultToken: 'BNB',
    contractsDeployed: true
  },
  
  // Ethereum - Sepolia enabled for testing
  ETHEREUM: {
    enabled: true, 
    mainnet: { id: 1, priority: 5 },
    testnet: { id: 11155111, priority: 3 },
    defaultToken: 'ETH',
    contractsDeployed: true
  },
  
  // Polygon
  POLYGON: {
    enabled: false,
    mainnet: { id: 137, priority: 6 },
    testnet: null,
    defaultToken: 'MATIC',
    contractsDeployed: false
  },
  
  // Base 
  BASE: {
    enabled: false,
    mainnet: { id: 8453, priority: 7 },
    testnet: null,
    defaultToken: 'ETH',
    contractsDeployed: false
  },
  
  // Arbitrum 
  ARBITRUM: {
    enabled: false,
    mainnet: { id: 42161, priority: 8 },
    testnet: null,
    defaultToken: 'ETH',
    contractsDeployed: false
  }
};

// Get all enabled chains
export const getEnabledChainIds = () => {
  const chains = [];
  Object.values(CHAIN_SETTINGS).forEach(setting => {
    if (setting.enabled) {
      if (setting.mainnet) chains.push(setting.mainnet);
      if (setting.testnet) chains.push(setting.testnet);
    }
  });
  return chains.sort((a, b) => a.priority - b.priority).map(c => c.id);
};

// Get primary chain (first enabled mainnet)
export const getPrimaryChain = () => {
  for (const setting of Object.values(CHAIN_SETTINGS)) {
    if (setting.enabled && setting.contractsDeployed && setting.mainnet) {
      return setting.mainnet.id;
    }
  }
  return 56; // Default to BSC
};

// Check if chain is supported
export const isChainSupported = (chainId) => {
  return getEnabledChainIds().includes(chainId);
};

// Get default token for chain
export const getDefaultTokenForChain = (chainId) => {
  for (const setting of Object.values(CHAIN_SETTINGS)) {
    if (setting.mainnet?.id === chainId || setting.testnet?.id === chainId) {
      return setting.defaultToken;
    }
  }
  return 'BNB'; // Default fallback
};

export const enableChain = (chainName) => {
  if (CHAIN_SETTINGS[chainName]) {
    CHAIN_SETTINGS[chainName].enabled = true;
  }
};

export const disableChain = (chainName) => {
  if (CHAIN_SETTINGS[chainName]) {
    CHAIN_SETTINGS[chainName].enabled = false;
  }
};

export const enableEthereum = () => {
  CHAIN_SETTINGS.ETHEREUM.enabled = true;
  CHAIN_SETTINGS.ETHEREUM.contractsDeployed = true;
};


export const enableAllChains = () => {
  Object.keys(CHAIN_SETTINGS).forEach(chain => {
    CHAIN_SETTINGS[chain].enabled = true;
    CHAIN_SETTINGS[chain].contractsDeployed = true;
  });
};